import { Controller } from "@hotwired/stimulus"

const FOCUSABLE = [
  "a[href]", "button:not([disabled])", "input:not([disabled]):not([type='hidden'])", "select:not([disabled])",
  "textarea:not([disabled])", "[tabindex]:not([tabindex='-1'])"
].join(",")

// Modal <dialog> (ERP::Modal::Component): opens from its trigger, closes on Escape (native), on the close
// button and on a backdrop click. Tab and Shift+Tab cycle inside the dialog. An open dialog is closed before
// Turbo caches the page, so a restored page never shows it open but inert. `open-on-connect` opens it with
// the page, for a window a link elsewhere leads to.
// Connects to data-controller="erp--modal"
export default class extends Controller {
  static targets = ["dialog"]
  static values = { openOnConnect: Boolean }

  connect() {
    this._onBeforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this._onBeforeCache)
    if (this.openOnConnectValue) this.open()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this._onBeforeCache)
    this.close()
  }

  open(event) {
    event?.preventDefault()
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // The dialog box fills the <dialog>: a click whose target is the <dialog> itself landed on the backdrop.
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  trapFocus(event) {
    if (event.key !== "Tab") return

    const focusable = [...this.dialogTarget.querySelectorAll(FOCUSABLE)].filter((element) => element.checkVisibility())
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
